<!-- eslint-disable max-len -->
<template>
  <div class="home">
    <HeaderLandingNew :custom-class="'z-index-2'" :is-dashboard="true" />
    <b-container fluid class="px-0 position-relative">
      <b-carousel
        id="carousel-1"
        :interval="4000"
        fade
        background="#ababab"
        img-width="100vw"
        img-height="63%"
        v-if="isDefaultPage"
      >
        <b-carousel-slide :img-src="bgSubscribeSlider" >
          <div class="d-flex flex-column w-51 " style="padding-bottom:8%">
            <span class="slider-title text-left">Partner with MusicVerse</span>
            <p class="text-left">Support Adventist musicians and global mission projects while listening to sacred music
            </p>
            <div class="d-flex" v-if="currentRoute !== 'TransactionSuccessPage'">
              <a :href="`/#/subscription`" class="learn-more " align="left" v-if="getUser.data.type === 0">JOIN</a>
            </div>
          </div>
          <div class="slider-image-subscribe">
            <img src="@/assets/person-subscribe.png" />
          </div>
        </b-carousel-slide>
        <b-carousel-slide :img-src="bgDonationsSlider" :class="'carousel-donation-home'">
          <div class="d-flex flex-column w-51 " style="padding-bottom:8%">
            <span class="slider-title text-left">Missions</span>
            <p class="text-left" style="margin-bottom: 4px;">Donate to MusicVerse to support missions</p>
            <p class="text-left">MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors</p>
          </div>

        </b-carousel-slide>
      </b-carousel>
      <div class="header-page w-100 position-relative" v-if="isCreditPage">
        <img :src="bgTopupSlider" class="w-100"/>
        <div class="header-title">
          <span>Pay-as-you-go</span>
        </div>
      </div>
      <div class="header-page w-100 position-relative" v-if="isSubscriptionPage">
        <img :src="bgSubscribeSlider" class="w-100"/>
        <div class="header-title">
          <span>Partner with MusicVerse</span>
          <p>A portion of your payment will go to missions</p>
        </div>
      </div>
      <b-carousel
        id="carousel-mission"
        :interval="4000"
        fade
        background="#ababab"
        img-width="100vw"
        img-height="63%"
        v-if="isDonationsPage"
      >
        <b-carousel-slide :img-src="bgDonationsSlider" :class="'carousel-donation-page'"  >
          <div class="d-flex flex-column w-51 " style="padding-bottom:8%">
            <span class="slider-title text-left">Missions</span>
            <p class="text-left" style="margin-bottom: 4px;">Donate to MusicVerse to support missions</p>
            <p class="text-left">MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors</p>
          </div>

        </b-carousel-slide>
      </b-carousel>
    </b-container>
    <b-container fluid style="margin-top:61px;min-height: 45vh;">
      <router-view></router-view>
    </b-container>
    <b-modal v-if="isMonthlySubscriber" ref="md-manage-subscription" v-model="toggleMM" id="md-manage-subscription"
             centered hide-footer title="Manage Subscription">
      <p class="text-center">Amount</p>
      <template v-if="isChangeAmount">
        <h2 class="text-center">${{userProfile.subscription.next_amount}}</h2>
        <p class="text-warning text-center" v-if="isMonthlySubscriber">
          New amount will be charged on {{moment(userProfile.subscription.schedule_start_date)}}
        </p>
      </template>
      <template v-else>
        <h2 class="text-center">${{userProfile.subscription.current_amount}}</h2>
        <p class="text-warning text-center" v-if="isMonthlySubscriber">
          Auto Renewal on {{moment(userProfile.subscription.end_date)}}
        </p>
      </template>
      <div class="d-flex justify-content-center mb-4" v-if="isMonthlySubscriber">
        <b-list-group class="w-75">
          <b-list-group-item
            class="d-flex align-items-center cursor-pointer"
            :disabled="isChangeAmount"
          >
            <a class="d-flex justify-content-between w-100 text-dark" :class="{'text-muted':isChangeAmount}" @click="goToChangeAmount">
              <span>Change Amount</span>
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </a>
          </b-list-group-item>
          <b-list-group-item class="d-flex align-items-center cursor-pointer">
            <a class="d-flex w-100 text-danger" @click="cancelSubscription">Cancel Subscription</a>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>
    <FooterLandingNew />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import defaultLogo from '@/assets/user-icon.png';
import bgTopupSlider from '@/assets/bg-topup-slider.jpg';
import bgSubscribeSlider from '@/assets/bg-subscribe-slider.jpg';
import bgDonationsSlider from '@/assets/bg-donations-slider.jpg';
import moment from 'moment';
import Vue from 'vue';
import HeaderLandingNew from '@/components/HeaderLandingNew';
import FooterLandingNew from '@/components/FooterLandingNew';
// import clevertap from 'clevertap-web-sdk';

const MV_URL = process.env.MUSICVERSE_URL;
const MV_URL_WP = process.env.MUSICVERSE_URL_WP;
export default {
  name: 'Dashboard',
  data: () => ({
    isShowDropdown: false,
    defaultLogo,
    bgTopupSlider,
    bgSubscribeSlider,
    bgDonationsSlider,
    mv_url: MV_URL,
    mv_url_wp: MV_URL_WP,
    userProfile: null,
    toggleMM: false,
  }),
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getToggleManageMembership']),
    ...mapGetters('AuthModule', ['accessToken', 'getUser']),
    isSubsriber() {
      if (this.userProfile) {
        if (this.userProfile.type === 1 && this.userProfile.subscription !== null) {
          return true;
        }
        return false;
      }
      return false;
    },
    isMonthlySubscriber() {
      if (this.isSubsriber) {
        // eslint-disable-next-line max-len
        const condition1 = this.userProfile.subscription.recurring === 1;
        const condition2 = !this.userProfile.subscription.canceled;
        const condition3 = this.userProfile.subscription.canceled && !this.userProfile.subscription.change_amount;
        if (condition1 && (condition2 || condition3)) {
          return true;
        }
      }
      return false;
    },
    isOneTimeSubscriber() {
      if (this.isSubsriber) {
        // eslint-disable-next-line max-len
        if ((this.userProfile.subscription.canceled || (!this.userProfile.subscription.canceled && this.userProfile.subscription.recurring === 0))) {
          return true;
        }
      }
      return false;
    },
    isChangeAmount() {
      if (this.isMonthlySubscriber) {
        if (this.userProfile.subscription.canceled && !this.userProfile.subscription.change_amount) {
          return true;
        }
      }
      return false;
    },
    currentRoute() {
      return this.$route.name;
    },
    isCreditPage() {
      return this.currentRoute === 'TopUpPage' || this.currentRoute === 'CheckoutPage' || this.currentRoute === 'SuccessPage';
    },
    isSubscriptionPage() {
      return this.currentRoute === 'SubscribePage' || this.currentRoute === 'SubscriptionCheckoutPage' || this.currentRoute === 'SubscriptionSuccessPage' || this.currentRoute === 'ChangeSubscriptionPage' || this.currentRoute === 'ChangeSubscriptionSuccessPage';
    },
    isDonationsPage() {
      return this.currentRoute === 'DonationListsPage' || this.currentRoute === 'DonationsPage' || this.currentRoute === 'DonationsCheckoutPage' || this.currentRoute === 'DonationsSuccessPage';
    },
    isDonationsListPage() {
      return this.currentRoute === 'DonationListsPage';
    },
    isDefaultPage() {
      return this.currentRoute === 'HomePage' || this.currentRoute === 'TransactionFailedPage' || this.currentRoute === 'TransactionSuccessPage';
    },
    getTitlePage() {
      const text = '';

      return text;
    },
  },
  mounted() {
    this.userProfile = this.getUser.data;
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'md-manage-subscription') {
        this.setManageMembership(false);
      }
    });
  },
  watch: {
    getToggleManageMembership: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (val === true) {
          await this.requestDetailUser();
          this.userProfile = this.getUser.data;
          this.toggleMM = true;
        } else {
          this.toggleMM = false;
        }
      },
    },
    getUser: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.userProfile = val.data;
      },
    },
  },
  methods: {
    ...mapActions('AuthModule', ['removeAuthentication', 'requestDetailUser']),
    ...mapActions('NotificationModule', ['setManageMembership']),
    ...mapActions('PaymentModule', ['requestCancelSubscription']),
    moment(date) {
      return moment(date)
        .format('DD MMMM YYYY');
    },
    async manageMembership() {
      this.setManageMembership(true);
    },
    async logout() {
      // eslint-disable-next-line max-len
      const result = await this.removeAuthentication({ accessToken: this.accessToken, tokenType: this.tokenType });
      if (result) {
        this.$router.go();
        window.location.reload();
      }
    },
    async cancelSubscription() {
      this.setManageMembership(false);
      Vue.swal({
        title: 'Cancel Membership',
        text: 'You will lose your premium perks, including listening offline and donation to ministries. Are you sure you want to cancel your membership?',
        icon: 'warning',
        confirmButtonText: 'Cancel Membership',
        cancelButtonText: 'I’ve Changed My Mind',
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-outline-primary',
          cancelButton: 'btn btn-primary',
        },
      })
        .then(async (result) => {
          if (result.value) {
            const resp = await this.requestCancelSubscription();
            if (resp) {
              await this.requestDetailUser();
              this.$swal('Membership Canceled', `You will have the premium access until ${this.moment(this.getUser.data.subscription.end_date)}. After that you won’t be charged for membership renewal.`, 'success');
            } else {
              this.$swal('Something Wrong. Please Try Again', '', 'error');
            }
          }
        });
    },
    goToChangeAmount() {
      this.setManageMembership(false);
      if (this.currentRoute !== 'ChangeSubscriptionPage') {
        this.$router.push({ name: 'ChangeSubscriptionPage' });
      }
    },
  },
  components: {
    HeaderLandingNew, FooterLandingNew
  },
};
</script>
<style>
@import '../assets/stylesheets/landing.css';
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue